export class SetCardsToWinRequest {
    static Message = 'SetCardsToWinRequest';
}

export class SetCardsToWinResponse {
    static Message = 'SetCardsToWinResponse';

    public cardsToWin: number;

    constructor(cardsToWin: number) {
        this.cardsToWin = cardsToWin;
    }
}
